import { notification } from 'antd';
import Axios, { AxiosError } from 'axios';
import { t } from 'helpers/i18n';
import { userServices } from 'services';
import { defaultPage, defaultPageSize } from '../constants/pagination';
import { IRequestParams, IDynamicSearch } from 'interfaces';
import '@terra-js/web-bridge';
import TerraKit from '@terra-js/terra-kit';

const handleResponseError = async (error: AxiosError) => {
  const status = error && error.response && error.response.status;
  switch (status) {
    case 401:
      if (TerraKit.isAvailable()) {
        const result = await TerraKit.auth().refreshAccessToken();
        error.config.headers['Authorization'] = 'Bearer ' + result.getValue();
        return Axios.request(error.config);
      }
      userServices.logout();
      break;
    case 403:
      userServices.denyAccess();
      break;
    default:
      let message = null;
      // Handle error message from API response
      if (error.response && error.response.data) {
        const { data } = error.response;
        message = data.message;
      }
      notification.error({
        message: t('Error'),
        description: message || t('SomethingWentWrong'),
      });
      break;
  }
};

export const convertRequestParams = (params: IRequestParams) => {
  const { page, page_size, fields, operators, values, direction } = params;
  return {
    operators: (operators || []).join(';'),
    fields: (fields || []).join(';'),
    values: (values || [])
      .map(m => (typeof m === 'object' && Array.isArray(m) ? m.join(',') : m))
      .join(';'),
    page: page || defaultPage,
    page_size: page_size || defaultPageSize,
    ...(direction ? { direction } : {}),
  } as IDynamicSearch;
};

export const getResult = (response: any) => response.data;
export const getData = (response: any) => response.data.data;

export default {
  handleResponseError,
  convertRequestParams,
};
